/**
 * ユーザー有効化/停止ダイアログ専用i18n定数
 */

export const USER_ACTIVATION_I18N = {
  // ステータス
  status: {
    active: $localize`:@@admin.userActivation.status.active:有効`,
    inactive: $localize`:@@admin.userActivation.status.inactive:無効`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.userActivation.button.close:閉じる`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@admin.userActivation.message.updateSuccess:更新が完了しました。`,
    updateError: $localize`:@@admin.userActivation.message.updateError:更新に失敗しました。再度お試しください。`,
  },

  // ユーザー名
  userName: {
    anonymous: $localize`:@@admin.userActivation.userName.anonymous:匿名計測者`,
  },
} as const;

export type UserActivationI18n = typeof USER_ACTIVATION_I18N;
